/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyJobRequest {
    getFixupPrototypeFunction() { return PolicyJobRequest.fixupPrototype; }

    static newInstance(model: Partial<PolicyJobRequest>): PolicyJobRequest {
        let obj = Object.assign(new PolicyJobRequest(), model);
        PolicyJobRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyJobRequest>): PolicyJobRequest {
        if (!model) return null;
        return PolicyJobRequest.newInstance(<PolicyJobRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyJobRequest) {
        if (!obj) return;

        models.PolicyJobRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyJobRequest): boolean {
        Object.setPrototypeOf(obj, PolicyJobRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
    }

    /**
     * Pagination context for violated_resources
     */
    list_context: models.ListContext;

}
